import { memo, FC, useCallback, useMemo } from 'react'

import { Toggle } from '@/components/Toggle/Toggle'
import { orientation } from '@/constants/focus'
import { useCustomFocus } from '@/hooks/useCustomFocus'
import {
  AdditionalSectionContentProps,
  AdditionalServiceSectionProps,
} from '@/types/componentsPropsTypes'

import {
  AdditionalSection,
  AdditionalSectionWrapper,
  AdditionalSectionTitle,
  AdditionalToggleContainer,
} from './styles'

const AdditionalSectionContentRaw: FC<AdditionalSectionContentProps> = ({
  services,
  slug,
  additionalSectionIsOpened,
  servicesDecision,
  setServicesDecision,
  tabTitle,
}) => {
  const focusId = `AdditionalSection_${slug}`
  const { defaultFocusChild, onMove } = useCustomFocus({ focusId })

  if (services?.length) {
    null
  }

  return (
    <AdditionalSectionWrapper
      orientation={orientation.VERTICAL}
      focusId={focusId}
      $isVisible={additionalSectionIsOpened}
      disabled={!additionalSectionIsOpened}
      defaultFocusChild={defaultFocusChild}
      onMove={onMove}
    >
      {services.map((service, index) => (
        <AdditionalServiceSection
          key={`AdditionalToggle__${slug}_${service.id}_${index}`}
          data={service}
          tabTitle={tabTitle}
          servicesDecision={servicesDecision}
          setServicesDecision={setServicesDecision}
        />
      ))}
    </AdditionalSectionWrapper>
  )
}

const AdditionalServiceSectionRaw: FC<AdditionalServiceSectionProps> = ({
  data,
  tabTitle,
  servicesDecision,
  setServicesDecision,
}) => {
  const serviceIsChecked = useMemo(() => {
    const service = servicesDecision.find((el) => el.serviceId === data.id)
    return service?.status || false
  }, [servicesDecision])

  const onToggleHandler = useCallback(
    (serviceId: string) => {
      setServicesDecision((prev) => {
        const servicesDecision = prev.map((service) =>
          service.serviceId === serviceId
            ? { serviceId, status: !serviceIsChecked }
            : service,
        )
        return servicesDecision
      })
    },
    [setServicesDecision, serviceIsChecked],
  )

  return (
    <AdditionalSection>
      <AdditionalSectionTitle>{data.name}</AdditionalSectionTitle>
      <AdditionalToggleContainer>
        <Toggle
          disabled={data.isEssential}
          checked={serviceIsChecked}
          onChange={onToggleHandler}
          id={data.id}
          focusId={`${tabTitle}_${data.id}`}
          small
        />
      </AdditionalToggleContainer>
    </AdditionalSection>
  )
}

const AdditionalServiceSection = memo(AdditionalServiceSectionRaw)
export const AdditionalSectionContent = memo(AdditionalSectionContentRaw)
